import React from 'react';

const NoData = () => {
  return (
    <div style={styles.container}>
      <img src="/images/cancel_17730571.png" alt="No Data" style={styles.image} />
      <p style={styles.message}>No Data Available</p>
    </div>
  );
};

// بعض الأنماط الخاصة بالتصميم
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '200px', // يمكن تعديل الارتفاع حسب الحاجة
    textAlign: 'center',
    padding: '20px',
  },
  image: {
    width: '60px', // حجم الصورة
    height: '60px',
    marginBottom: '10px',
  },
  message: {
    fontSize: '18px',
    color: 'red', // اللون الأحمر
    fontWeight: 'bold',
  },
};

export default NoData;
